import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://enewaurasolutions.in/api',
  timeout: 15000,
});

// Attach token
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getMe: () => API.get('/auth/me'),
  updateProfile: (data) => API.put('/auth/profile', data),
  changePassword: (data) => API.put('/auth/change-password', data),
};

// Products
export const productAPI = {
  getAll: (params) => API.get('/products', { params }),
  getOne: (slug) => API.get(`/products/${slug}`),
  create: (data) => API.post('/products', data),
  update: (id, data) => API.put(`/products/${id}`, data),
  delete: (id) => API.delete(`/products/${id}`),
  getMy: (params) => API.get('/products/seller/my', { params }),
  getSellerProducts: (params) => API.get('/products/seller/my', { params }),
  addReview: (id, data) => API.post(`/products/${id}/reviews`, data),
};

// Categories
export const categoryAPI = {
  getAll: (params) => API.get('/categories', { params }),
  create: (data) => API.post('/categories', data),
  update: (id, data) => API.put(`/categories/${id}`, data),
  delete: (id) => API.delete(`/categories/${id}`),
};

// Uploads
export const uploadAPI = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return API.post('/upload', formData);
  },
};

// Wishlist
export const wishlistAPI = {
  get: () => API.get('/wishlist'),
  toggle: (data) => API.post('/wishlist', data),
};

// Orders
export const orderAPI = {
  create: (data) => API.post('/orders', data),
  getMy: (params) => API.get('/orders', { params }),
  getAll: (params) => API.get('/orders', { params }),
  getOne: (id) => API.get(`/orders/${id}`),
  cancel: (id) => API.put(`/orders/${id}/cancel`),
  verifyPayment: (data) => API.post('/orders/verify-payment', data),
  updateStatus: (id, status) => API.put(`/admin/orders/${id}/status`, { status }),
};

// Addresses
export const addressAPI = {
  get: () => API.get('/addresses'),
  add: (data) => API.post('/addresses', data),
  delete: (id) => API.delete(`/addresses/${id}`),
};

// Notifications
export const notificationAPI = {
  get: () => API.get('/notifications'),
  markRead: () => API.put('/notifications/read'),
};

// Admin
export const adminAPI = {
  getDashboard: () => API.get('/admin/dashboard'),
  getUsers: (params) => API.get('/admin/users', { params }),
  toggleUserStatus: (id) => API.put(`/admin/users/${id}/toggle`),
  toggleUser: (id) => API.put(`/admin/users/${id}/toggle`),
  getOrders: (params) => API.get('/admin/orders', { params }),
  updateOrderStatus: (id, status) => API.put(`/admin/orders/${id}/status`, { status }),
  getCoupons: () => API.get('/admin/coupons'),
  createCoupon: (data) => API.post('/admin/coupons', data),
  deleteCoupon: (id) => API.delete(`/admin/coupons/${id}`),
  getInventory: (params) => API.get('/admin/inventory', { params }),
  adjustStock: (id, data) => API.put(`/inventory/${id}/adjust`, data),
  getStockHistory: (id) => API.get(`/inventory/${id}/history`),
};

export default API;
